import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useRoleCache } from './cache'
import { type RoleData, type UnsavedRole, type RoleAddInput, type RoleAddSuccess } from '@terros/common'

export function useAddRole(): AddHookResponse<UnsavedRole, RoleData> {
  const cache = useRoleCache()
  const mutation = useTantalimMutation<RoleAddInput, RoleAddSuccess>({ url: '/role/add' })

  async function add(role: UnsavedRole): Promise<RoleData> {
    const output = await mutation.mutateAsync({ role })
    cache.clearList()
    return output.role
  }

  return mutationAdd(mutation, add)
}
